import React, { useCallback, useEffect, useMemo, useState } from 'react'
import { PanelMessageIn } from './types'

import { useSendMessage } from './useSendMessage'

import { getHost } from './utilities'

declare global {
  interface Window {
    sketchup?: any
    chrome?: any
  }
}

export const useRunCommand = (
  defaultKey?: string
) => {
  const host = getHost()

  const { sendMessage } = useSendMessage()

  const [key, setKey] = useState(defaultKey ?? performance.now().toString())

  useEffect(() => {
    if (!defaultKey) return
    setKey(defaultKey)
  }, [defaultKey])

  const rhinoRunCommand = useCallback((commandString: string | {
    name: string,
    param: string }, commandOptions?: any) => {
    const msgObject: PanelMessageIn = {
      data: commandString,
      options: commandOptions,
      uniqueId: key
    }
    sendMessage('AddCommand', msgObject)
  }, [key, sendMessage])

  const runCommand = useMemo(() => {
    switch (host) {
      case 'rhino':
        return rhinoRunCommand
      default:
        return undefined
    }
  }, [host, rhinoRunCommand])

  return {
    host,
    runCommand,
  }
}
